module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-row', [_c('el-col', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "list__header"
  }, [_c('p', {
    staticClass: "list__title"
  }, [_vm._v("\n                    Zdjęcia w galerii\n                ")])]), _vm._v(" "), _c('el-upload', {
    staticClass: "upload",
    attrs: {
      "drag": "",
      "http-request": _vm.uploadImage,
      "action": "",
      "multiple": ""
    }
  }, [_c('i', {
    staticClass: "el-icon-upload"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-upload__text"
  }, [_vm._v("Przeciągnij plik tutaj lub "), _c('em', [_vm._v("kliknij aby dodać")])])]), _vm._v(" "), _c('el-table', {
    staticClass: "list__table",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.images,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "id",
      "width": "70"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "zdjęcie"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('img', {
          staticClass: "thumbnail",
          attrs: {
            "src": scope.row.thumbnail,
            "alt": scope.row.alt_pl
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "autor"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(_vm.imageDuringEdition(scope.row)) ? _c('el-input', {
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.duringEditing[scope.row.id].author),
            callback: function($$v) {
              _vm.$set(_vm.duringEditing[scope.row.id], "author", $$v)
            },
            expression: "duringEditing[scope.row.id].author"
          }
        }) : _vm._e(), _vm._v(" "), _c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (!_vm.imageDuringEdition(scope.row)),
            expression: "!imageDuringEdition(scope.row)"
          }]
        }, [_vm._v(_vm._s(scope.row.author))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "alt (pl)"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(_vm.imageDuringEdition(scope.row)) ? _c('el-input', {
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.duringEditing[scope.row.id].alt_pl),
            callback: function($$v) {
              _vm.$set(_vm.duringEditing[scope.row.id], "alt_pl", $$v)
            },
            expression: "duringEditing[scope.row.id].alt_pl"
          }
        }) : _vm._e(), _vm._v(" "), _c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (!_vm.imageDuringEdition(scope.row)),
            expression: "!imageDuringEdition(scope.row)"
          }]
        }, [_vm._v(_vm._s(scope.row.alt_pl))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "alt (en)"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(_vm.imageDuringEdition(scope.row)) ? _c('el-input', {
          attrs: {
            "type": "text"
          },
          model: {
            value: (_vm.duringEditing[scope.row.id].alt_en),
            callback: function($$v) {
              _vm.$set(_vm.duringEditing[scope.row.id], "alt_en", $$v)
            },
            expression: "duringEditing[scope.row.id].alt_en"
          }
        }) : _vm._e(), _vm._v(" "), _c('span', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (!_vm.imageDuringEdition(scope.row)),
            expression: "!imageDuringEdition(scope.row)"
          }]
        }, [_vm._v(_vm._s(scope.row.alt_en))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    staticClass: "pull-right",
    attrs: {
      "label": "opcje",
      "width": "250"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (!_vm.imageDuringEdition(scope.row)),
            expression: "!imageDuringEdition(scope.row)"
          }],
          attrs: {
            "title": "Edytuj szczegóły zdjęcia",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.editImage(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-edit"
        })]), _vm._v(" "), _c('el-button', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.imageDuringEdition(scope.row)),
            expression: "imageDuringEdition(scope.row)"
          }],
          attrs: {
            "title": "Zatwierdź edycję",
            "size": "small",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.submitEditedImage(scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-check"
        })]), _vm._v(" "), (scope.$index !== _vm.images.length - 1) ? _c('el-button', {
          attrs: {
            "size": "small",
            "title": "Przesuń w dół"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.changeOrder(_vm.images, scope.$index, 1)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-arrow-down"
        })]) : _vm._e(), _vm._v(" "), _c('el-button', {
          style: ({
            opacity: scope.$index !== 0 ? 1 : 0
          }),
          attrs: {
            "size": "small",
            "title": "Przesuń do góry"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.changeOrder(_vm.images, scope.$index, -1)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-arrow-up"
        })]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "danger",
            "size": "small",
            "title": _vm.$t('delete')
          },
          on: {
            "click": function($event) {
              return _vm.removeItemFromFormset(_vm.images, scope.row)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-delete"
        })])]
      }
    }])
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-13621864"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Gallery/Galleries/GalleryImages.vue
// module id = 716
// module chunks = 0